const isNumber = value => {
  return !isNaN(parseFloat(value))
}

const formatNumberToString = value => {
  return isNumber(value) ? String(value) : ''
}

export default {
  isNumber,
  formatNumberToString,
}
